<div [formGroup]="form">
  <div>
    <h3>Emails</h3>

    <mat-label>Do Not Contact</mat-label> &nbsp; <mat-checkbox (change)="selectDNC()" [checked]="form.value.DNC"></mat-checkbox>

    <ng-container formArrayName="items">
      @for (item of items.controls; track item; let idx = $index) {
        <div [formGroupName]="idx">
          @if (!item.value.toValidate) {
            <span>
              <mat-label>Primary? </mat-label><mat-checkbox (change)="selectPrimary(idx)" [checked]="item.value.primary"></mat-checkbox><br />
            </span>
          } @else {
            Email Awaiting Validation<br />
          }
          <mat-form-field  appearance="outline" >
            <mat-label>Type</mat-label>
            <mat-select matNativeControl  formControlName="type" required>
              @for (nns of contactTypes; track nns) {
                <mat-option [value]="nns">
                  {{ nns }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          @if (!item.value.primary) {
            <span>
              <mat-form-field  appearance="outline" >
                <mat-label>Email</mat-label>
                <input matInput
                  formControlName="value"
                  id="value"
                  email="true"
                  (blur)="checkUnique(idx)"
                  />
              </mat-form-field>
              <button mat-button type="button" (click)="removeEmailItem(idx)"> <mat-icon>delete</mat-icon></button>
            </span>
          } @else {
            <br/>{{ item.value.value }} 	<span (mouseenter)="changeText=true" (mouseleave)="changeText=false">
            @if (!changeText) {
              <span><span class="material-icons">help_outline</span></span>
            }
            @if (changeText) {
              <span> Can't edit the Primary Email</span>
            }
          </span>
        }
      </div>
    }

    @if (checkCanAdd()) {
      <span>
        <button mat-button type="button" (click)="addEmailItem()">Add New Email</button><br></span>
      } @else {
        Unable to add additional EMails - {{ totalToValidate }} already requiring Validation
      }

    </ng-container>
  </div>
</div>